export const LineaCarga = ()=> {
    return(
        <div className="loader-line"></div>
    )

}